export default __webpack_public_path__ + "static/media/298.33a624b9.jpg";